import { X } from "lucide-react";

const ErrorState: React.FC<{
  message: string;
  onRetry: () => void;
  onClose: () => void;
}> = ({ message, onRetry, onClose }) => (
  <div className="w-[500px] mx-auto">
    <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
      <X className="w-12 h-12 text-red-500 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-red-900 mb-2">Analysis Failed</h3>
      <p className="text-sm text-red-700 mb-6">{message}</p>
      <div className="flex gap-3 justify-center">
        <button
          onClick={onClose}
          className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          Close
        </button>
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
        >
          Try Again
        </button>
      </div>
    </div>
  </div>
);

export default ErrorState;
